// CSS
import './styles/global.scss';

// Global variables
var sq = sq || {};
window.sq = sq;
